module.exports = __webpack_public_path__ + "static/PAV_banner_backgroud-2819514124622c90a4274ce6bf78bfc2.png";